import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = ["AIR ROASTED", "ZERO BITTERNESS", "SMALL BATCH", "FLAVOR INFUSED", "NASHVILLE MADE", "ROASTED TO ORDER", "GREMLIN ENERGY"];

export const Ticker = () => (
  <div data-testid="marquee-ticker" className="bg-ember text-void py-4 border-y-2 border-void select-none">
    <Marquee speed={55} gradient={false} autoFill>
      {ITEMS.map((t) => (
        <span key={t} className="mx-8 font-display font-black uppercase tracking-tight text-xl md:text-2xl inline-flex items-center gap-8">
          {t} <span className="text-void/50">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
